



































































































































































































































import { Vue, Component, Watch, Ref } from "vue-property-decorator";

import { DevicesModule } from "@/store/modules/DevicesModule";

import DeviceItem from "./DeviceItem.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { DeviceCategoryTemplate } from "@/data/models/DeviceCategoryTemplate";
import {
  getCategoryIdFromSerialNumber,
  getUpdatedCategoryAndTemplateIds,
  getTemplateIdFromSerialNumber,
  isClientPanel,
  isIresTemplate,
} from '@/data/models/DeviceSettingsManager'
import { DeviceTemplate } from "@/data/models/DeviceTemplate";
import { getDefaultBranchFilterOfUser, getReactiveActiveUser } from "@/data/repository/UserRepository";
import { GenericDeviceFilter, getGenericFilterName, matchesGenericDeviceFilter } from "@/data/models/DeviceFilter";
import ClientPanel from "@/data/models/ClientPanel";
import BranchFilterSelectorComponent from "../common/BranchFilterSelector.vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import MenuIconWithSelectionListComponent from "../common/FilterMenu.vue";
import SearchForDeviceComponent from "../devices/SearchForDevice.vue";
import { getNumber, setNumber } from "@/utils/SecureLocalStorage";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { getBranchName } from "@/data/models/Branch";
import { findBranch, hasClientEnabledStrictBranchFilters, shouldHideSerialNumber } from "@/data/repository/ClientRepository";
import { BranchFilter } from "@/data/models/BranchFilter";
import router from "@/router/router";
import { getClientPanelsRef, observeClientPanelsIncludingTemporaryAssignment, updateClientPanelsBySerialNumber } from "@/data/repository/ClientPanelRepository";
import { observeDeviceOverviews } from "@/data/repository/AllDevicesRepository";
import { filterRetainedDevices } from "@/utils/DeviceManagementUtils";
import { COLOR_DISABLED, COLOR_HEADER_BUTTON, COLOR_PRIMARY, COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";
import { DELETION_SEPARATOR, calculateBackgroundStyle, getReleasedQrCodes, getUpdatedIdsAfterDeletion, setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import { getClientDevicesRef, updateDevicesById } from "@/data/repository/GenericDeviceRepository";
import MultiDevicesDetailsDialog from "./MultiDevicesDetailsDialog.vue";
import { editAllDevicesAccess } from "@/permissions/UserPermissions";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { getAllVehiclesOfClient, removeDevicesFromVehicleMapBatch } from "@/data/repository/VehicleRepository";
import Vehicle from "@/data/models/Vehicle";
import ToolbarOverflowItemComponent from "@/components/common/ToolbarOverflowItem.vue";
import { getStoredBranchFilterId, setStoredBranchFilterId, removeStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component({
  components: {
    "toolbar-overflow-item": ToolbarOverflowItemComponent,
    "branch-filter-selector": BranchFilterSelectorComponent,
    "device-item": DeviceItem,
    "infinite-loading": InfiniteLoading,
    "menu-icon": MenuIconWithSelectionListComponent,
    "search-for-device": SearchForDeviceComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "multi-devices-details-dialog": MultiDevicesDetailsDialog,
  },
})

export default class AllDevicesListComponent extends Vue {
  allDevices: ClientPanel[] = [];
  allFilters = [
    GenericDeviceFilter.ALL_DEVICES,
    GenericDeviceFilter.IN_USAGE,
    GenericDeviceFilter.AVAILABLE,
    GenericDeviceFilter.NOT_AVAILABLE,
  ];
  componentActive = false;
  forceUpdateBackgroundColor = false;
  hasNoClientPanels = true;
  hasNoOtherDevices = true;
  infiniteId = new Date();
  isLoading = true;
  noOfSlicedClientPanels = 0;
  pageSize = 20;
  refreshTimer!: NodeJS.Timeout;
  refreshTrigger = 0;
  searchQuery: string | null = null;
  searchQueryKey = "SearchQuery";
  searchTimeout: NodeJS.Timeout | null = null;
  selectedBranchFilter = getDefaultBranchFilterOfUser();
  selectedDeviceFilter = GenericDeviceFilter.ALL_DEVICES;
  showNoDevicesMessage = false;
  sliceLength = this.pageSize;
  sortedTemplateIds: string[] = [];
  storageKeyAllDevicesFilter = "storageKeyAllDevicesFilter";
  storageKeyBranchFilter = "AllDevicesBranchFilter";
  storageKeySliceLength = "allDevicesListStorageKeySliceLength";
  subscriptions: Array<() => void> = [];
  timer: NodeJS.Timeout | null = null;
  windowWidth = 0;

  noOfFilteredClientPanels = 0;
  noOfFilteredDeviceOverviews = 0; 

  retrievedClientPanels: ClientPanel[] = [];
  retrievedDeviceOverviews: DeviceOverview[] = [];
  vehicles: Vehicle[] = [];

  isSelectionMode = false;
  isDeletingDevices = false;

  selectedClientPanels: ClientPanel[] = [];
  selectedDeviceOverviews: DeviceOverview[] = [];

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  showingErrorSnackbar = false;
  errorSnackbarText = "";

  snackbarTimeout = 5000;

  @Ref("confirmDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Ref("multiDevicesDetailsDialog")
  deviceDetailsDialog!: MultiDevicesDetailsDialog; 

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get colorPrimary() {
    return COLOR_PRIMARY;
  }

  get categories() {
    return DevicesModule.selectedCategories;
  }

  get clientPanels() {
    return this.categories.length === 1
      ? this.retrievedClientPanels.filter((clientPanel) => getCategoryIdFromSerialNumber(clientPanel.serialNumber) === this.categories[0].id)
      : this.retrievedClientPanels;
  }

  get deviceFilterIconRes() {
    return "mdi-filter-variant";
  }

  get deviceOverviews() {
    const retrievedDeviceOverviews = this.deviceOverviewsWithUpdatedCategoryAndTemplateIds;

    return this.categories.length === 1 
      ? retrievedDeviceOverviews.filter((deviceOverview) => deviceOverview.categoryId === this.categories[0].id)
      : retrievedDeviceOverviews;
  }

  /**
   * Iterates over each device overview, updating the category and template IDs based on shared device settings.
   * This method leverages the `getUpdatedCategoryAndTemplateIds` function to find the updated category and template IDs
   * from the shared device settings that correspond to the local settings for each device. It then updates these IDs
   * in the device overview list.
   *
   * @returns {DeviceOverview[]} An array of device overview objects with updated category and template IDs.
   */
  get deviceOverviewsWithUpdatedCategoryAndTemplateIds() {
    const deviceOverviews = this.retrievedDeviceOverviews;

    deviceOverviews.forEach((device) => {
      const { updatedCategoryId, updatedTemplateId } = getUpdatedCategoryAndTemplateIds(
        device.categoryId,
        device.templateId,
        this.localDeviceSettingsJson,
        this.sharedDeviceSettingsJson,
        device.devicePowerUsageType ?? undefined,
      );

      device.categoryId = updatedCategoryId;
      device.templateId = updatedTemplateId;
    });

    return deviceOverviews;
  }

  get clientPanelsToDisplay() {
    return this.sliceClientPanelsToDisplay(this.sliceLength);
  }

  get otherDevicesToDisplay() {
    return this.sliceOtherDevicesToDisplay(this.sliceLength);
  }

  get isDefaultBranchFilterSelected() {
    return this.selectedBranchFilter.isDefaultBranchFilter();
  }

  get showInfiniteLoading() {
    return this.clientPanelsToDisplay.length > 0 || this.otherDevicesToDisplay.length > 0;
  }

  get categoriesToDisplay() {
    return this.categories;
  }

  get hasNoDevices() {
    return this.hasNoClientPanels && this.hasNoOtherDevices;
  }

  get areSelectionActionsEnabled() {
    return this.selectedClientPanels.length > 0 || this.selectedDeviceOverviews.length > 0;
  }

  get isEditingAllowedForSelection() {
    return this.areSelectionActionsEnabled;
  }

  get isDeletionAllowedForSelection() {
    const isClientPanelAssignedToProject = this.selectedClientPanels.find((clientPanel) => clientPanel.currentProjectId !== null);
    const isOtherDeviceAssignedToProject = this.selectedDeviceOverviews.find((device) => device.currentlyAssigned);

    return this.areSelectionActionsEnabled && !isClientPanelAssignedToProject && !isOtherDeviceAssignedToProject;
  }

  get showSwitchSelectionModeIcon() {
    return this.isSelectionMode || 
      (
        !this.showNoDevicesMessage &&
        (
          this.clientPanelsToDisplay.length > 0 ||
          this.otherDevicesToDisplay.length > 0
        )
      );
  }

  get isAllowedToEditDevices() {
    const user = getReactiveActiveUser();

    if (!user) {
      return false;
    }

    return editAllDevicesAccess(user);
  }

  get numberOfDevices() {
    return this.noOfFilteredClientPanels + this.noOfFilteredDeviceOverviews;
  }

  get numberOfDevicesSelected() {
    return this.selectedDeviceOverviews.length + this.selectedClientPanels.length;
  }

  get selectedDeviceFiltersDescription() {
    const numberOfDevices = this.numberOfDevices;
    const numberOfDevicesSelected = this.numberOfDevicesSelected;

    let filtersName = this.isSelectionMode
      ? this.$tc("allDevices.descriptionAlt", numberOfDevicesSelected).toString()
      : this.$tc("allDevices.description", numberOfDevices).toString();
    let isFilterEnabled = false;

    // Might use later
    /* const selectedClientFilterName = this.selectedClientFilter.client
      ? getClientName(this.selectedClientFilter.client)
      : this.$t("common.all");

    if (this.isAllowedToViewClientSelector && selectedClientFilterName !== this.$t("common.all")) {
      filtersName += " (" + selectedClientFilterName;
      isFilterEnabled = true;
    } */

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName(this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += !isFilterEnabled
        ? " ("
        : "";
      filtersName += /* (this.isAllowedToViewClientSelector
        ? ": "
        : "") +  */selectedBranchFilterName;
      isFilterEnabled = true;
    }

    return filtersName + (isFilterEnabled ? ")" : "");
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get shouldHideSerialNumber() {
    return shouldHideSerialNumber();
  }

  @Watch("hasNoClientPanels")
  onHasNoClientPanelsChanged() {
    this.processDevicesChange();
  }

  @Watch("hasNoOtherDevices")
  onHasNoOtherDevicesChanged() {
    this.processDevicesChange();
  }

  @Watch("selectedBranchFilter")
  onBranchFilterChanged() {
    this.resetDevices();
    this.storeBranch();
  }

  @Watch("selectedDeviceFilter")
  onFilterChanged(newFilter: GenericDeviceFilter) {
    this.setToolbarTitle(newFilter);
    this.resetDevices();

    setNumber(this.storageKeyAllDevicesFilter, this.selectedDeviceFilter);
  }

  calculateBackgroundStyle(itemId: string) {
    return calculateBackgroundStyle(itemId, StorageKeyLastVisitedItemLevel.LEVEL_3);
  }

  showSuccessSnackbar(message: string) {
    this.showingSuccessSnackbar = true;
    this.successSnackbarText = message;
  }

  showErrorSnackbar(message: string) {
    this.showingErrorSnackbar = true;
    this.errorSnackbarText = message;
  }

  toggleSelectionMode() {
    this.selectedClientPanels = [];
    this.selectedDeviceOverviews = [];

    setLastVisitedItem(
      null,
      StorageKeyLastVisitedItemLevel.LEVEL_3
    );

    this.isSelectionMode = !this.isSelectionMode;
  }

  async editSelectedDevices() {
    if (this.isSelectionMode) {
      this.deviceDetailsDialog.show();
    }
  }

  async deleteSelectedDevices() {
    const result = await this.confirmationDialog.show({
      title: this.$t("allDevices.deletionConfirmationDialog.title").toString(),
      message: this.$t("allDevices.deletionConfirmationDialog.message").toString(),
      acceptMessage: this.$t("common.delete").toString(),
    });

    if (result) {
      this.isDeletingDevices = true;
      const deletedClientPanelsInventoryNumbers = (
        await getUpdatedIdsAfterDeletion(
          this.selectedClientPanels.map(clientPanel => clientPanel.inventoryNumber ?? ""),
          "inventoryNumber",
          getClientPanelsRef()
        )
      );

      const deletedDeviceOverviewsInventoryNumbers = (
        await getUpdatedIdsAfterDeletion(
          this.selectedDeviceOverviews.map(deviceOverview => deviceOverview.inventoryNumber ?? ""),
          "inventoryNumber",
          getClientDevicesRef()
        )
      );

      // Each QR code is released alongside its inventory number, so the label can go on another device.
      const releasedClientPanelQrCodes = await getReleasedQrCodes(
        new Map<string, string | null | undefined>(
          this.selectedClientPanels.map(clientPanel => [clientPanel.serialNumber, clientPanel.qrCode])
        ),
        getClientPanelsRef()
      );

      const releasedDeviceQrCodes = await getReleasedQrCodes(
        new Map<string, string | null | undefined>(
          this.selectedDeviceOverviews.map(deviceOverview => [deviceOverview.id, deviceOverview.qrCode])
        ),
        getClientDevicesRef()
      );

      if (
        deletedClientPanelsInventoryNumbers.size === this.selectedClientPanels.length &&
        deletedDeviceOverviewsInventoryNumbers.size === this.selectedDeviceOverviews.length &&
        releasedClientPanelQrCodes &&
        releasedDeviceQrCodes
      ) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedClientPanels = new Map<string, any>();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedOtherDevices = new Map<string, any>();

        const devicesToBeRemovedFromVehicles = new Map<string, string[]>();

        deletedClientPanelsInventoryNumbers.forEach((updatedInventoryNumber, originalInventoryNumber) => {
          const clientPanel = this.selectedClientPanels.find(
            (clientPanel) =>
              (
                (
                  !clientPanel.inventoryNumber &&
                  updatedInventoryNumber[0] === DELETION_SEPARATOR
                ) ||
                clientPanel.inventoryNumber === originalInventoryNumber
              ) && 
              !updatedClientPanels.has(clientPanel.serialNumber)
          );

          if (clientPanel) {
            const vehicleId = clientPanel.vehicleId;
            if (vehicleId) {
              const existingDeviceList = devicesToBeRemovedFromVehicles.get(vehicleId);

              if (existingDeviceList) {
                existingDeviceList.push(clientPanel.serialNumber);
              } else {
                devicesToBeRemovedFromVehicles.set(vehicleId, [clientPanel.serialNumber]);
              }
            }

            updatedClientPanels.set(
              clientPanel.serialNumber,
              {
                inventoryNumber: updatedInventoryNumber,
                availability: -1,
                vehicleId: null,
                ...(releasedClientPanelQrCodes.has(clientPanel.serialNumber)
                  ? { qrCode: releasedClientPanelQrCodes.get(clientPanel.serialNumber) }
                  : {})
              }
            )
          }
        });

        deletedDeviceOverviewsInventoryNumbers.forEach((updatedInventoryNumber, originalInventoryNumber) => {
          const deviceOverview = this.deviceOverviews.find(
            (deviceOverview) =>
              (
                (
                  !deviceOverview.inventoryNumber &&
                  updatedInventoryNumber[0] === DELETION_SEPARATOR
                ) ||
                deviceOverview.inventoryNumber === originalInventoryNumber
              ) && 
              !updatedOtherDevices.has(deviceOverview.id)
          );

          if (deviceOverview) {
            const vehicleId = deviceOverview.vehicleId;
            if (vehicleId) {
              const existingDeviceList = devicesToBeRemovedFromVehicles.get(vehicleId);

              if (existingDeviceList) {
                existingDeviceList.push(deviceOverview.id);
              } else {
                devicesToBeRemovedFromVehicles.set(vehicleId, [deviceOverview.id]);
              }
            }

            updatedOtherDevices.set(
              deviceOverview.id,
              {
                inventoryNumber: updatedInventoryNumber,
                availability: -1,
                vehicleId: null,
                ...(releasedDeviceQrCodes.has(deviceOverview.id)
                  ? { qrCode: releasedDeviceQrCodes.get(deviceOverview.id) }
                  : {})
              }
            )
          }
        });

        const [isUpdateClientPanelsSuccessful, isUpdateOtherDevicesSuccessful] = await Promise.all([
          updateClientPanelsBySerialNumber(updatedClientPanels),
          updateDevicesById(updatedOtherDevices),
          removeDevicesFromVehicleMapBatch(devicesToBeRemovedFromVehicles)
        ]);

        if (isUpdateClientPanelsSuccessful) {
          this.selectedClientPanels = [];
        }

        if (isUpdateOtherDevicesSuccessful) {
          this.selectedDeviceOverviews = [];
        }
      
        if (isUpdateClientPanelsSuccessful && isUpdateOtherDevicesSuccessful) {
          this.isSelectionMode = false;
          this.showSuccessSnackbar("allDevices.deletionConfirmationDialog.successMessage");
        }
        else {
          this.showErrorSnackbar("allDevices.deletionConfirmationDialog.errorMessage");
        }
      }
      else {
        this.showErrorSnackbar("allDevices.deletionConfirmationDialog.errorMessage");
      }

      this.isDeletingDevices = false;
    }
  }

  getEditIconColor() {
    return this.isEditingAllowedForSelection
      ? COLOR_HEADER_BUTTON
      : COLOR_DISABLED;
  }

  getDeleteIconColor() {
    return this.isDeletionAllowedForSelection
      ? COLOR_HEADER_BUTTON
      : COLOR_DISABLED;
  }

  isClientPanelSelected(clientPanel: ClientPanel) {
    return this.selectedClientPanels.includes(clientPanel);
  }

  isOtherDeviceSelected(device: DeviceOverview) {
    return this.selectedDeviceOverviews.includes(device);
  }

  async infiniteHandler(data: StateChanger) {
    const nextSliceLength = this.sliceLength + this.pageSize;
    const nextSlice = [
      ...this.sliceClientPanelsToDisplay(nextSliceLength),
      ...this.sliceOtherDevicesToDisplay(nextSliceLength)
  ];

    this.sliceLength = nextSliceLength;

    if (nextSliceLength > nextSlice.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }
  
  clearSearchQuery() {
    this.searchQuery = null;
    this.resetDevices();
  }

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.processSearchQuery(newQuery);
    }, 400);
  }

  filterDevices(devices: (DeviceOverview | ClientPanel)[]) {
    const filter = this.selectedDeviceFilter;
    const branchFilter = this.selectedBranchFilter;
    const searchQuery = this.searchQuery?.toUpperCase();
    const isDefaultBranchFilterSelected = this.isDefaultBranchFilterSelected;

    const result = devices.filter((device: DeviceOverview | ClientPanel) =>
        (
          branchFilter.doesMatchGenericDevice(device) ||
          isDefaultBranchFilterSelected
        ) &&
        matchesGenericDeviceFilter(
          filter,
          device
        )
      );

    if (searchQuery) {
      const searchQueryLowerCase = searchQuery.toLowerCase();

      const searchedDevices = result.filter(
        (device: DeviceOverview | ClientPanel) => {
          if (isClientPanel(device)) {
            const panel = device as ClientPanel;

            return (
                panel.serialNumber
                  .toLowerCase()
                  .includes(searchQueryLowerCase) &&
                !this.shouldHideSerialNumber
              ) ||
              panel.inventoryNumber
                ?.toLowerCase()
                .includes(searchQueryLowerCase)
          }
          else {
            const deviceOverview = device as DeviceOverview;

            return deviceOverview.serialNumber
                ?.toLowerCase()
                .includes(searchQueryLowerCase) ||
              deviceOverview.qrCode
                ?.toLowerCase()
                .includes(searchQueryLowerCase) ||
              deviceOverview.inventoryNumber
                ?.toLowerCase()
                .includes(searchQueryLowerCase)
          }
        });
        
        return this.isSelectionMode ? filterRetainedDevices(searchedDevices) : searchedDevices;
    }

    return filterRetainedDevices(result);
  }

  focusSearchInput() {
    this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const searchInputRef = this.$refs.searchInput as any;

      if (searchInputRef && typeof searchInputRef.focus === 'function') {
        searchInputRef.focus();
      }
    })
  }

  getFilteredAllDevices(templateId: string) {
    if (isIresTemplate(templateId)) {
      return this.clientPanelsToDisplay.filter((panel) => {
        return getTemplateIdFromSerialNumber(panel.serialNumber) === templateId;
      });
    }

    return this.otherDevicesToDisplay.filter((device) => device.templateId === templateId);
  }

  getVehicle(device: DeviceOverview | ClientPanel) {
    if (!device.vehicleId) {
      null;
    }

    const vehicle = this.vehicles.find((v) => v.id === device.vehicleId);

    return vehicle ?? null;
  }

  getAllFiltersName() {
    let filtersName = this.getGenericFilterName(this.selectedDeviceFilter);

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName(this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += ", " + selectedBranchFilterName;
    }

    return filtersName;
  }

  getFilteredOtherDevices(templateId: string) {
    return this.otherDevicesToDisplay.filter((device) => device.templateId === templateId);
  }

  getFilteredPanels(templateId: string) {
    return this.clientPanelsToDisplay.filter((panel) => {
      return getTemplateIdFromSerialNumber(panel.serialNumber) === templateId;
    });
  }

  getGenericFilterName(deviceFilter: GenericDeviceFilter) {
    return getGenericFilterName(this, deviceFilter);
  }

  getSortedTemplates(deviceTemplates: DeviceTemplate[]) {
    return deviceTemplates.sort((a, b) => a.deviceName.localeCompare(b.deviceName));
  }

  isFirstTemplateWithDevices(category: DeviceCategoryTemplate, currentTemplateId: string) {
    if (this.categories.length <= 1) {
      return false;
    }

    const firstTemplateWithDevices = category.deviceTemplates.find(template => 
      this.filterDevices(this.getFilteredAllDevices(template.id)).length > 0
    );
    return firstTemplateWithDevices?.id === currentTemplateId;
  }

  isIresDeviceTemplate(templateId: string) {
    return isIresTemplate(templateId);
  }

  onOpenDeviceDetails(device: DeviceOverview | ClientPanel, isClientPanel: boolean) {
    if (!this.isSelectionMode) {
      const index = isClientPanel
        ? this.clientPanelsToDisplay.indexOf(device as ClientPanel)
        : this.otherDevicesToDisplay.indexOf(device as DeviceOverview);

      setNumber(
        this.storageKeySliceLength,
        this.pageSize + Math.floor(index / this.pageSize) * this.pageSize
      );

      this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;
    }
    else {
      if (isClientPanel) {
        const clientPanel = device as ClientPanel;
        const index = this.selectedClientPanels.indexOf(clientPanel, 0);
        
        if (index > -1) {
          this.selectedClientPanels.splice(index, 1);
        }
        else {
          this.selectedClientPanels.push(clientPanel);
        }
      }
      else {
        const deviceOverview = device as DeviceOverview;
        const index = this.selectedDeviceOverviews.indexOf(deviceOverview, 0);
        
        if (index > -1) {
          this.selectedDeviceOverviews.splice(index, 1);
        }
        else {
          this.selectedDeviceOverviews.push(deviceOverview);
        }
      }
    }
  }

  processDevicesChange() {
    if (this.hasNoDevices) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.timer = setTimeout(() => {
          this.isLoading = false;
          this.showNoDevicesMessage = true;
        }, 1000);
      }
    } else {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.isLoading = false;
      this.showNoDevicesMessage = false;
    }
  }

  processSearchQuery(newQuery: string) {
    this.searchQuery = newQuery;
    this.resetDevices();
  }

  resetDevices() {
    this.hasNoClientPanels = false;
    this.hasNoOtherDevices = false;
    this.showNoDevicesMessage = false;
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
  }

  storeBranch() {
    if (this.selectedBranchFilter.branch?.id) {
      setStoredBranchFilterId(this.storageKeyBranchFilter, this.selectedBranchFilter.branch.id);
    }
    else {
      removeStoredBranchFilterId(this.storageKeyBranchFilter);
    }
  }

  setToolbarTitle(newFilter: GenericDeviceFilter) {
    const baseTitle = this.$t("pages.allDevices").toString();
    const commonAll = this.$t("common.all").toString();


    let toolbarTitle = baseTitle + " > " + commonAll;

    if (this.categories.length === 1) {
      toolbarTitle = `${baseTitle} > ${this.categories[0].categoryName} > ${commonAll}`;
    }

    const devicesString = this.selectedDeviceFilter === GenericDeviceFilter.ALL_DEVICES
      ? `${toolbarTitle}`
      : `${toolbarTitle} (${this.getGenericFilterName(newFilter)})`

    ToolbarContentModule.setToolbarTitle(devicesString);
  }

  sliceClientPanelsToDisplay(length: number) {
    this.hasNoClientPanels = true;
    const clientPanels = this.filterDevices(this.clientPanels
      .sort((a, b) => {
        if (a.inventoryNumber && b.inventoryNumber) {
          return a.inventoryNumber.localeCompare(b.inventoryNumber);
        }

        return a.serialNumber.localeCompare(b.serialNumber);
      })
      .sort((a, b) => {
        const templateIdA = getTemplateIdFromSerialNumber(a.serialNumber);
        const templateIdB = getTemplateIdFromSerialNumber(b.serialNumber);

        const indexA = this.sortedTemplateIds.indexOf(templateIdA);
        const indexB = this.sortedTemplateIds.indexOf(templateIdB);
        return indexA - indexB;
      }));

    this.noOfFilteredClientPanels = clientPanels.length;
    this.hasNoClientPanels = this.noOfFilteredClientPanels === 0;
    
    const slicedClientPanels = clientPanels.slice(0, length) as ClientPanel[];
    this.noOfSlicedClientPanels = slicedClientPanels.length;

    return slicedClientPanels;
  }

  sliceOtherDevicesToDisplay(length: number) {
    this.hasNoOtherDevices = true;
    const deviceOverviews = this.filterDevices(
      this.deviceOverviews
        .sort((a, b) => a.inventoryNumber.localeCompare(b.inventoryNumber))
        .sort((a, b) => {
          const indexA = this.sortedTemplateIds.indexOf(a.templateId);
          const indexB = this.sortedTemplateIds.indexOf(b.templateId);
          return indexA - indexB;
        })
    );

    this.noOfFilteredDeviceOverviews = deviceOverviews.length;
    this.hasNoOtherDevices = this.noOfFilteredDeviceOverviews === 0;

    // Ensure device overviews are loaded only after all client panels have loaded.
    const loadDeviceOverviews = 
      this.noOfSlicedClientPanels === this.filterDevices(this.clientPanels).length ||
      this.hasNoClientPanels;
    const slicedDeviceOverviews = deviceOverviews.slice(0, loadDeviceOverviews ? length : 0) as DeviceOverview[];
    
    return slicedDeviceOverviews;
  }

  startRefreshTimer() {
    this.refreshTimer = setInterval(() => {
      this.refreshTrigger++;
    }, 60 * 1000);
  }

  toClientPanels(devices: (DeviceOverview | ClientPanel)[]) {
    return devices as ClientPanel[];
  }

  toOtherDevices(devices: (DeviceOverview | ClientPanel)[]) {
    return devices as DeviceOverview[];
  }

  activated() {
    this.componentActive = true;
    this.setToolbarTitle(this.selectedDeviceFilter);
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => subscription());
    clearInterval(this.refreshTimer);
  }

  async created() {
    const vehicles = await getAllVehiclesOfClient();
    this.vehicles = vehicles;

    const cachedDeviceFilter =
      getNumber(this.storageKeyAllDevicesFilter) ?? GenericDeviceFilter.ALL_DEVICES;

    if (cachedDeviceFilter != null && cachedDeviceFilter !== undefined) {
      this.selectedDeviceFilter = cachedDeviceFilter;
    }

    const cachedSliceLenth = getNumber(this.storageKeySliceLength);
    if (cachedSliceLenth) {
      this.sliceLength = cachedSliceLenth;
      setNumber(this.storageKeySliceLength);
    }

    setTimeout(() => {
      if (this.hasNoDevices) {
        this.isLoading = false;
        this.showNoDevicesMessage = true;
      }
    }, 800);

    this.setToolbarTitle(this.selectedDeviceFilter);
  }

  deactivated() {
    this.componentActive = false;
  }

  mounted() {
    const branchIdQuery = getStoredBranchFilterId(this.storageKeyBranchFilter);

    if (branchIdQuery) {
      const matchingBranch = findBranch(branchIdQuery);

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }

    const cachedSearchedQuery = localStorage.getItem(this.searchQueryKey);

    if (cachedSearchedQuery) {
      localStorage.removeItem(this.searchQueryKey);
      
      this.searchQuery = cachedSearchedQuery;
    }

    this.subscriptions.push(observeDeviceOverviews(
      (deviceOverviews: Array<DeviceOverview>) => {
        this.retrievedDeviceOverviews = deviceOverviews;
      }
    ));
    this.subscriptions.push(observeClientPanelsIncludingTemporaryAssignment(
      (clientPanels: Array<ClientPanel>) => {
        this.retrievedClientPanels = clientPanels;
      }
    ));

    this.startRefreshTimer();

    this.categories.forEach(category => {
      category.deviceTemplates.forEach(template => {
        this.sortedTemplateIds.push(template.id);
      });
    });

    this.componentActive = true;

    const isSearchFocused = router.currentRoute.query["search"] as string;

    if (isSearchFocused && isSearchFocused === "true") {
      this.focusSearchInput();
    }
  }
}
